import React, {memo} from "react";
import PropTypes from "prop-types";
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import Loader from "../../Loader";

const ConfirmModal = (props) => {
  const {
    header = "",
    modalBody = "",
    onClose = () => {},
    onConfirm = () => {},
    open,
  } = props;

  return (
    <Modal unmountOnClose={true} isOpen={open} backdrop={"static"} size={"md"}>
      <Loader />
      <ModalHeader>{header}</ModalHeader>
      <ModalBody>{modalBody}</ModalBody>
      <ModalFooter>
        <Button color={"danger"} data-cy={"confirm-btn"} onClick={onConfirm}>
          YES
        </Button>
        <Button onClick={onClose} data-cy={"cancel-btn"}>
          CANCEL
        </Button>
      </ModalFooter>
    </Modal>
  );
};

function areEqual(prevProps, nextProps) {
  return prevProps.open === nextProps.open;
}

ConfirmModal.propTypes = {
  /** Title of modal */
  header: PropTypes.string.isRequired,
  /** Content of modal */
  modalBody: PropTypes.string.isRequired,
  /** Callback function which will be executed on cancel */
  onClose: PropTypes.func.isRequired,
  /** Callback function which will be executed on confirm */
  onConfirm: PropTypes.func.isRequired,
  /** State to set whether modal is open */
  open: PropTypes.bool.isRequired,
};

export default memo(ConfirmModal, areEqual);
